/**
 * True when the website is shown inside the AI CRM Android app. The app has its own top bar and
 * navigation, so the website then shows only the page itself (no second menu or header).
 * The app opens /handoff?embed=1; the flag lasts for that in-app browsing session.
 */
export const embedded: boolean = (() => {
  try {
    if (new URLSearchParams(window.location.search).get('embed') === '1') sessionStorage.setItem('aicrm-embedded', '1');
    return sessionStorage.getItem('aicrm-embedded') === '1';
  } catch {
    return false;
  }
})();
